const apiBaseUrlList: Record<string, string> = {
  "dev": "https://campaign-product-display.t-dtap.sf.albelli.com",
  "tst": "https://campaign-product-display.t-dtap.sf.albelli.com",
  "acc": "https://campaign-product-display.a-dtap.sf.albelli.com",
  "prod": "https://campaign-product-display.sf.albelli.com"
}

export default apiBaseUrlList;